module.exports = __webpack_public_path__ + "static/media/groupauto_logo.57ba035b.svg";